import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import logo from '../asset/logo.png';
import { FaBars, FaTimes } from 'react-icons/fa';
import '../styles/Navbar.css';
import Swal from 'sweetalert2';

const Navbar = () => {
  const { logout } = UserAuth();
  const navRef = useRef();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const result = await Swal.fire({
        title: 'Konfirmasi Keluar',
        text: 'Apakah Anda yakin ingin keluar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      });

      if (result.isConfirmed) {
        await logout();
        navigate('/');
        navRef.current.classList.remove('responsive_nav');
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const showNavbar = () => {
    navRef.current.classList.toggle('responsive_nav');
  };

  const hideNavbar = () => {
    navRef.current.classList.remove('responsive_nav');
  };

  return (
    <div className='navbar-detail'>
      <div className='navbar-container'>
        <div className='nav-left nav-wrapper'>
          <div className='nav-left merk-wrapper'>
            <img src={logo} alt='logo' width='50px' />
            <h2 className='nav-left__merk'>Qurtal</h2>
            <div className='barrier'></div>
          </div>
          <nav ref={navRef} className='nav-left'>
            <Link to={'/beranda'} className='nav-link' onClick={hideNavbar}>
              Beranda
            </Link>
            <Link to={'/hafalan'} className='nav-link' onClick={hideNavbar}>
              Hafalan
            </Link>
            <Link to={'/kontak'} className='nav-link' onClick={hideNavbar}>
              Bantuan
            </Link>
            <Link onClick={handleLogout} className='nav-link logout-btn'>
              Keluar
            </Link>
            <button className='nav-btn nav-close-btn'>
              <FaTimes onClick={showNavbar} />
            </button>
          </nav>
          <button className='nav-btn' onClick={showNavbar}>
            <FaBars />
          </button>
        </div>
        <div className='nav-right'>
          <button onClick={handleLogout} className='nav-right__logout'>
            Keluar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
